import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';

const PageMain = ({ children }) => (
  <Container
    as="main"
    fluid={'xl'}
  >
    {children}
  </Container>

);

PageMain.propTypes = {
  children: PropTypes.node
};

export default PageMain;
